import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PluginComponent } from '../plugin.component';
import { Inspection } from '../../shared/models/index';
import { BasePlugin } from '../base-plugin.component';

@Component({
    templateUrl: './customerremark.component.html',
    standalone: false
})
export class CustomerRemarkPluginComponent extends BasePlugin implements OnInit {
  public plugin: any = {};
  inspectionId: string;
  public inspection: Inspection;
  public remarks: any;

  constructor(private route: ActivatedRoute, private cdRef: ChangeDetectorRef) {
    super();
  }

  ngOnInit() {}

  config(
    plugin: any,
    inspection: Inspection,
    messages: Array<string>,
    showBreadcrumbs: boolean,
    showValidations: boolean,
    showContent: boolean
  ): void {
    super.config(plugin, inspection, messages, showBreadcrumbs, showValidations, showContent);
    this.remarks = this.plugin.config.Remarks;
    this.cdRef.detectChanges();
  }

  initData() {}

  getEditRoute() {
    return [
      this.inspectionsRoute,
      this.inspection.id,
      'points',
      this.plugin.pointId ? this.plugin.pointId : -1,
      'plugins',
      this.plugin.id,
      'customerremark',
      'edit'
    ];
  }
}

PluginComponent.plugins['customerremark'] = CustomerRemarkPluginComponent;
